export default __webpack_public_path__ + "static/media/two.5c8a9577.jpg";